import MapboxDraw, { DrawCustomMode, DrawCustomModeThis } from "@mapbox/mapbox-gl-draw";

import { createMeasurementVertex, displayStartEndVertexes } from "./utils";

const ExtendedDirectSelectMode = {
    ...MapboxDraw.modes.direct_select,

    toDisplayFeatures: function (
        state: { feature: GeoJSON.Feature },
        geojson: GeoJSON.Feature,
        display: (geojson: GeoJSON.GeoJSON) => void,
    ) {
        const originalToDisplayFeatures = MapboxDraw.modes.direct_select.toDisplayFeatures;
        originalToDisplayFeatures.call(this as DrawCustomModeThis & DrawCustomMode<unknown, unknown>, state, geojson, display);
        displayStartEndVertexes(geojson, display);

        if (!state.feature.id || state.feature.id !== geojson.properties?.id) return;

        switch (geojson.geometry.type) {
            case "LineString":
            case "Polygon":
            case "MultiPolygon":
                return display(createMeasurementVertex(geojson, state.feature.id, getFirstCoordinate(geojson.geometry)));
        }
    },
};

function getFirstCoordinate(geometry: GeoJSON.Geometry): GeoJSON.Position {
    switch (geometry.type) {
        case "LineString":
            return geometry.coordinates[0];
        case "Polygon":
            return geometry.coordinates[0][0];
        case "MultiPolygon":
            return geometry.coordinates[0][0][0];
        default:
            throw new Error(`Unsupported geometry type: ${geometry.type}`);
    }
}

export default ExtendedDirectSelectMode;
